export default {
  thankYou: {
    title: "Thank You!",
    message: "Your form has been successfully submitted. We appreciate your interest in our services and will process your request as soon as possible.",
    contactInfo: "If you have any questions, feel free to contact us at +36 20 801 2837, +36 70 734 3444 or info@atgroup.hu.",
    homeButton: "BACK TO HOME",
    contactButton: "CONTACT US"
  },
  cookieConsent: {
    title: "Cookie Settings",
    message: "We use cookies to enhance your browsing experience, serve personalized content, and analyze our traffic. By clicking 'Accept', you consent to our use of cookies.",
    accept: "Accept",
    decline: "Decline",
    categories: {
      necessary: "Necessary Cookies",
      necessaryDesc: "These cookies are required for the website to function and cannot be switched off. They are usually only set in response to actions made by you.",
      analytics: "Analytics Cookies",
      analyticsDesc: "These cookies help us understand how visitors interact with our website by collecting and reporting information anonymously.",
      marketing: "Marketing Cookies",
      marketingDesc: "These cookies are used to track visitors across websites to display relevant advertisements.",
      preferences: "Preference Cookies",
      preferencesDesc: "These cookies allow the website to remember choices you make and provide enhanced, more personal features."
    }
  },
  common: { // Added common section
    back: "Back"
  },
  nav: {
    home: "HOME",
    booking: "BOOKING",
    about: "ABOUT US",
    services: "SERVICES & PRICES",
    taxi: "TAXI",
    contact: "CONTACT",
    faq: "FAQ"
  },
  faq: {
    title: "Frequently Asked Questions",
    subtitle: "Service, tires and detailing — the answers you need in one place.",
    viewAll: "View all questions",
    contactCta: "Need a quick answer?",
    contactButton: "Contact us"
  },
  hero: {
    welcome: "Welcome to A&T Group!",
    subtitle: "Where we offer solutions for all your car needs in one place!",
    cta: "BOOK NOW"
  },
  booking: {
    title: "BOOK A SPOT",
    button: "Book Airport Parking",
    // --- New Booking Page Content ---
    content: {
      sectionTitle: "Airport Parking Booking Details",
      paragraph1: "Welcome to our online booking system. Please provide the necessary information below to reserve your parking spot at A&T Group near the airport.",
      paragraph2: "Our facility is located just minutes from the airport and offers a secure, convenient parking solution for your trip.",
      paragraph3: "After submitting your request, you will receive a confirmation email with all details regarding your booking, including directions and check-in procedures.",
      note: "If you have any special requests or require assistance, please contact us directly."
    }
    // --- End New Content ---
  },
  services: {
    title: "OUR SERVICES",
    parking: {
      title: "24/7 AIRPORT PARKING",
      description: "Our secure parking facility features fenced boundaries and 24-hour camera surveillance, guaranteeing the highest security for your vehicle."
    },
    washing: {
      title: "CAR WASH",
      description: "Treat your vehicle to a spa day with our professional car washing services aimed at keeping your car looking sparkling clean and youthful."
    },
    tire: {
      title: "TIRE SERVICE",
      description: "Our expert technicians are ready to solve any tire-related problems immediately and get you safely back on the road."
    },
    service: {
      title: "AUTO SERVICE",
      description: "From routine checks to complex repairs, our qualified mechanics are equipped to perform all maintenance."
    }
  },
  testimonials: {
    title: "Customer Testimonials",
    viewAll: "View all testimonials"
  },
  cta: {
    discover: "Discover our competitive prices – check them out now!",
    button: "View Price List"
  },
  footer: {
    visit: "VISIT US",
    address: "Next to Vecsés Széchényi Street 62, Plot 0182/55, 2220",
    phone: "Phone",
    phoneNumber: "+36 20 801 2837, +36 70 734 3444",
    email: "Email",
    emailAddress: "info@atgroup.hu",
    links: "Links",
    copyright: "© 2025 atgroup.hu. All rights reserved."
  }
};